import { isEmpty } from 'lodash';
import { REGION_FIELD_DATA, regionFieldConfigKeys } from '~/consts/generalSettings';
import { RegionAttribute } from '~/definitions/region';

function getSelectedRegionUpdateAttributes(attributes: RegionAttribute[], number?: string, value?: string) {
    const attributesToUpdate: RegionAttribute[] = [];

    attributes.forEach((attr: RegionAttribute) => {
        let attribute: RegionAttribute = {};

        regionFieldConfigKeys.forEach((key) => {
            const field = REGION_FIELD_DATA[key];
            if (attr.number === field.name) {
                attribute = { ...attr, value: attr?.value || '' };
            }
        });

        if (number) {
            const field = REGION_FIELD_DATA[number as string];
            if (attr.number === field.name) {
                attribute = { ...attribute, value: value || '' };
            }
        }

        if (!isEmpty(attribute)) {
            attributesToUpdate.push(attribute);
        }
    });

    return attributesToUpdate;
}

export default getSelectedRegionUpdateAttributes;
